<template>
    <abonnementen :attach="true"></abonnementen>
</template>

<script>

import Prijzen from "../../Prijzen";
import Abonnementen from "../../Abonnementen";
export default {
    components: {Abonnementen, Prijzen},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
